import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PopUp from '../../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
// import Animation from '../../../../../../animations/fallingTower.json';
import Lottie from 'react-lottie';
import iconErrorcard from '../images/icon-errorcard.svg';

const PopUpPaymentError = (props) => {


  return (
        <PopUp showPopUp={props.isDisplayErrorPopup} onClose={props.closePopUp} className='popUp-payment-error'>
        <h2>מצטערים, משהו השתבש <br/>והעסקה לא בוצעה בהצלחה!</h2>
        {/* <img /> */}
        {/* <Lottie options={{animationData: Animation, loop: false}} width={200} height={200} /> */}
        <p>{props.content}</p>
        <BtnSubmit
              isBusiness={false}
              text={"נסו שוב"}
              onclick={props.onclickTryAgainBtn}
              formid={'sale-payment-error-popup'}
              isDisplayArrows={false}
            />
      </PopUp>
  );
};

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PopUpPaymentError);
